import React from "react";
import './download-product-options.scss';
import {DownloadProduct} from "../download-product";
import {Dropdown} from "../../../dropdown";
import {updateProduct} from "../../download-publish-modal-reducer";
import {connect} from "react-redux";
import {ANALYTICS_DOWNLOAD_CATEGORY} from "../../../../libraries/download-panel-library";

/**
 * Renders the quality section in the download panel
 *
 * @author Ahsan Ejaz <ahsan@250mils.com>
 */
export class DownloadProductOptions extends React.Component {
    constructor(props) {
        super(props);
    }

    render = () => {
        if (this.props.productsList.length > 1) {
            return <div className={'quality-container'}>
                <h3 className={'section-heading body-lg-bold'}>{i18next.t('pmwjs_quality')}</h3>
                <div className={'products-list'}>
                    <Dropdown dropdownItems={this.#prepareDownloadProductList(this.props.productsList)}
                              defaultDataValue={this.#getDefaultProductId(this.props.productsList)}
                              dropdownClasses={'quality-dropdown -primary'}
                              clickHandler={this.#setSelectedProduct}
                              portalDomId={'download-panel-dropdown-portal'}
                              title={i18next.t('pmwjs_quality')}
                              showDropdownAsModalForMobile={true}
                              dropdownItemMobileClasses='spacing-p-t-3 spacing-p-b-3 spacing-p-r-4 spacing-p-l-4'
                    />
                </div>
            </div>;
        } else {
            return null
        }
    }

    /**
     * @param {string} itemId
     */
    #setSelectedProduct = (itemId) => {
        let selectedItem = this.#getProductForGivenId(itemId)
        PMW.redux.store.dispatch(updateProduct(selectedItem));
    }

    /**
     * @param {string} productId
     * @returns {null|*}
     */
    #getProductForGivenId = (productId) => {
        for (let i = 0; i < this.props.productsList.length; i++) {
            let currentItem = this.props.productsList[i];
            if(currentItem.id === productId) {
                return currentItem
            }
        }
        return null
    }

    /**
     *
     * @param {Array} listItems
     * @returns {*}
     */
    #prepareDownloadProductList = (listItems) => {
        return (
            listItems.map((item) => {
                return {
                    label: <DownloadProduct product={item}/>,
                    dataValue: item.id,
                    itemData: item
                }
            })
        )
    }

    /**
     * @param {array} listItems
     * @returns {null|*}
     */
    #getDefaultProductId(listItems) {
        if (listItems.length > 0) {
            const defaultItem = this.props.selectedProduct ? this.props.selectedProduct : listItems[0]; //selecting first item as default
            return defaultItem.id
        }
        return null
    }
}

const mapDownloadProductOptionsStateToProps = state => {
    return {
        selectedProduct: state.downloadPanel.selectedProduct,
        productsList: state.downloadPanel.productsList
    }
}
//codeReviewAhsan: can create a  mapDispatchToProps and pass as second argument to connect()
export default connect(mapDownloadProductOptionsStateToProps)(DownloadProductOptions)
